export default {
      id: "pin-outline-usage",
      viewBox: "0 0 12 19",
      url: __webpack_public_path__ + "img/icons.507a1d9d.svg#pin-outline",
      toString: function () {
        return this.url;
      }
    }